"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LooseObject;
(function (LooseObject) {
    class LooseObjKit {
        constructor() {
            this.object = {};
            this.object = {};
        }
        setAttr(key, content) {
            this.object[key] = content;
        }
        deleAttr(key) {
            delete this.object[key];
        }
        get() {
            return this.object;
        }
    }
    LooseObject.LooseObjKit = LooseObjKit;
})(LooseObject = exports.LooseObject || (exports.LooseObject = {}));
//# sourceMappingURL=loose.object.kit.js.map